import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { useProjectDetail } from 'lib/hooks/project/useProjectDetail';
import { useProjectDetailStore } from 'store/local/projectDetail';
import { T } from 'components/common/text';
import ProjectDetailInformation from './ProjectDetailInformation';
import SelectedTeethList from './SelectedTeethList';
import { useProject } from 'lib/hooks/project/useProject';
import ProjectTeeth from './ProjectTeeth';
import ProjectVoiceMemo from './ProjectVoiceMemo';
import ProjectTeethPhotogrammetry from './ProjectTeethPhotogrammetry';
import { FormControlLabel, Radio, RadioGroup } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import MuiWrapper from 'components/common/input/MuiWrapper';

interface ProjectContentsInfoProps {
  className?: string;
}

function ProjectContentsInfo({ className }: ProjectContentsInfoProps) {
  const { t } = useTranslation();
  const {
    bridge,
    teeth,
    setTeeth,
    tooth,
    setTooth,
    numbering,
    selectedTeethIsExpanded,
    isPhotogrammetry,
    setIsPhotogrammetry,
  } = useProjectDetailStore();
  const {
    handleSelectedIndicationChange,
    handleSetTeethExpanded,
    handleEditIndication,
    onDeleteTooth,
  } = useProjectDetail();

  const { projectInfo, isMultidie, indicationInfo, materialShadeList, isPim, projectIndication } =
    useProject();

  const [toggleTriger, setToggleTriger] = useState<boolean>(false);
  const [pimRadio, setPimRadio] = useState<'Y' | 'N'>(!!isPim ? 'Y' : 'N');
  const dentistryList = [
    {
      key: 'N',
      title: t('GLOBAL_NORMAL'),
    },
    {
      key: 'Y',
      title: t('GLOBAL_PHOTOGRAMMETRY'),
    },
  ];

  const handleToggleSelectTooth = (toothNumber: number) => {
    // setToggleTriger(true);
    // setTooth(tooth);
    handleEditIndication(toothNumber);
  };

  useEffect(() => {
    if (!toggleTriger) return;
    handleSetTeethExpanded(tooth, true);
    setToggleTriger(false);
  }, [tooth, toggleTriger]);

  useEffect(() => {
    setIsPhotogrammetry(!!isPim);
  }, []);

  const handleChangeDentistryType = (e: any) => {
    setPimRadio(e.target.value);
    setIsPhotogrammetry(e.target.value === 'Y' ? true : false);
  };

  return (
    <StyledProjectContentsInfo
      data-component-name="ProjectContentsInfo"
      $isThumbnail={!!projectInfo?.thumbnailUrl}
      className={className}
    >
      <div className="projectContentsInfo__container">
        <div className="projectContentsInfo__box left">
          <ProjectDetailInformation />

          <div className="projectContentsInfo__dentisrty_type_box">
            <span>
              <T>PROJECT_SELECT_DENTISTRY_TYPE</T>
            </span>

            <MuiWrapper className="row_contents_wrapper gender">
              <RadioGroup
                className="dentisrty_type_group"
                aria-label="refund"
                name="pim"
                value={pimRadio}
                onChange={handleChangeDentistryType}
              >
                {dentistryList?.length > 0 &&
                  dentistryList.map((item, index) => {
                    return (
                      <FormControlLabel
                        key={index}
                        value={item.key}
                        control={<Radio color="primary" size="small" />}
                        className="dentisrty_type_radio_box"
                        label={<div className="gender_label">{item.title}</div>}
                      />
                    );
                  })}
              </RadioGroup>
            </MuiWrapper>
          </div>
          <div className="projectContentsInfo__left_item teeth_list_box">
            <SelectedTeethList
              isMultidie={isMultidie}
              isViewer={true}
              numbering={numbering}
              teeth={teeth}
              bridge={bridge}
              selectedTeethIsExpanded={selectedTeethIsExpanded}
              indicationInfo={indicationInfo}
              materialShadeList={materialShadeList}
              onSelectedIndicationChange={handleSelectedIndicationChange}
              onDeleteTooth={onDeleteTooth}
            />
          </div>
        </div>
        <div className="projectContentsInfo__box center">
          <div className="projectContentsInfo__center_item indication">
            {isPhotogrammetry ? (
              <ProjectTeethPhotogrammetry
                isViewer
                teeth={teeth}
                setTeeth={setTeeth}
                tooth={tooth}
                setTooth={setTooth}
                onToggleTooth={handleToggleSelectTooth}
              />
            ) : (
              <ProjectTeeth
                isViewer
                bridge={bridge}
                teeth={teeth}
                onToggleTooth={handleToggleSelectTooth}
              />
            )}
          </div>
        </div>
        <div className="projectContentsInfo__box right">
          <ProjectVoiceMemo />
        </div>
      </div>
    </StyledProjectContentsInfo>
  );
}

const StyledProjectContentsInfo = styled.div<{ $isThumbnail: boolean }>`
  position: relative;
  background-color: #fff;
  border-radius: 10px;
  .projectContentsInfo__container {
    display: flex;
    position: relative;
    padding: 30px;
    height: 710px;
    overflow: hidden;
    align-items: center;
    justify-content: space-between;
    .projectContentsInfo__box {
      display: flex;
      flex-direction: column;
      height: 100%;
      &.left {
        width: 480px;
        justify-content: space-between;
        .teeth_list_box {
          height: 270px;
        }
      }

      &.center {
        width: 460px;
        height: 100%;
        display: flex;
        flex-direction: column;
        /* justify-content: ${({ $isThumbnail }) =>
          !!$isThumbnail ? 'space-between' : 'center'}; */
        justify-content: center;
        align-items: center;
        position: relative;
        .thumbnail {
          .thumbnail_img {
            height: 215px;
            width: auto;
          }
        }
        .indication {
          /* height: 370px; */
          /* width: 215px; */
          /* width: ${({ $isThumbnail }) => (!!$isThumbnail ? '215px' : '353px')}; */
          width: 353px;
        }
        .projectContentsInfo__button_box {
          position: absolute;
          width: 100%;
          bottom: 0;
          display: flex;
          justify-content: flex-end;
          .projectContentsInfo__content_button {
            height: 38px;
            display: flex;
            align-items: center;
          }
        }
      }

      &.right {
        width: 480px;
        justify-content: space-between;
        .memo_box {
          width: 100%;
          height: 200px;
          padding: 10px;
          border: 1px solid #e1e1e7;
          border-radius: 3px;
        }
      }

      .projectContentsInfo__dentisrty_type_box {
        display: flex;
        justify-content: space-between;
        align-items: center;
        .dentisrty_type_group {
          .dentisrty_type_radio_box {
            display: flex;
            justify-content: flex-end;
            align-items: center;
          }
        }
      }
    }
  }
  .project__modify_button {
    position: absolute;
    display: flex;
    width: 100%;
    justify-content: center;
    margin-top: 20px;
  }
`;

export default ProjectContentsInfo;
